export default {
    // 中
    zhCN: {
        area: '区域',
        monthly_case_count: '月度案件数', // 月度案件数
        monthly_closed: '月度已关闭', // 月度已关闭
        monthly_closure_rate: '月度关闭率', // 月度关闭率
        accumulated_closure_rate: '累计关闭率', // 累计关闭率
        case_count_closure_rate: '案例数与关闭率',
        Key_market_technical_support_performance_statistics: '重点市场技术支持表现统计',
        Accumulated_case_count: '累计案件数',
        Accumulated_closure_count: '累计关闭数',
        month_case_count: '月案件数',
        month_closure_count: '月关闭数',
        five_Day_closure_rate: '天数关闭率',
        five_Day_closure_count: '5天关闭数',
        response_count_24hour: '24小时答复数',
        response_rate_24hour: '24小时回复率',
        month_response_rate_24hour: '24小时回复率',
        form_type: '表单类型',
        repeat_multiple_choice_msg: '月份与区域不可同时多选！',
        day_closure_rate: '天关闭率',
        months_case_count: '月度案件数',
        individually: '个体',
        full: '全部',
        received: '收到',
        report: '上报',
        regional_abbreviations: '区域简称',
        name_of_organisation: '组织名称',
        form_of_documents: '单据形式',
        statistical_coverage: '统计范围',
        requiredMsg: '必填信息未填写!',
        singlemonth_multiregional_composite_map: '整合报表',
        statistical_for_tw_weeks: '近12周数据',
        weekly_case_count: '周案件数',
        accu_mon_sel_simultaneously: '月度案件数 与 累计关闭率不能同时选择！',
        mcc_mm_sr: '月度案件数请选择多月单区域',
        acr_mm_sr: '累计关闭率请选择单月多区域',
        distribution_Holding: '保有量分布',
        hour_response_rate: '答复率',
        Vehicle_fleet_size: '车型保有量',
        num_of_cases: '案例数',
        ratio: '比例',
        techl_inquiry_ratio: '技术问询比例',
        close_logic: '关闭率统计',
        case_closure_rate: '案件关闭率',
        technical_closure_rate: '技术关闭率',
        doc_stats_scope: '单据统计范围',
    },
    // 英
    enUS: {
        area: 'Area',
        monthly_case_count: 'Monthly Case Count', // 月度案件数
        monthly_closed: 'Monthly Closed', // 月度已关闭
        monthly_closure_rate: 'Monthly Closure Rate', // 月度关闭率
        accumulated_closure_rate: 'Accumulated Closure Rate', // 累计关闭率
        case_count_closure_rate: 'Case Count and Closure Rate',
        Key_market_technical_support_performance_statistics:
            'Key market technical support performance statistics',
        Accumulated_case_count: 'Accumulated case count',
        Accumulated_closure_count: 'Accumulated closure count',
        month_case_count: 'month case count',
        month_closure_count: 'month closure count',
        five_Day_closure_rate: 'Days Close Rate',
        five_Day_closure_count: 'Five day closure count',
        response_count_24hour: 'response count 24 hour',
        response_rate_24hour: 'response rate 24 hour',
        month_response_rate_24hour: 'response rate 24 hour',
        form_type: 'Form Type',
        repeat_multiple_choice_msg: 'Month and region cannot be selected at the same time!',
        day_closure_rate: 'day closure rate',
        months_case_count: 'number of cases per month',
        individually: 'Individually',
        full: 'Full',
        received: 'Received',
        report: 'Report',
        regional_abbreviations: 'Regional Abbreviations',
        name_of_organisation: 'Name Of Organisation',
        form_of_documents: 'Form Of Documents',
        statistical_coverage: 'Statistical Coverage',
        requiredMsg: 'Mandatory information not filled in!',
        singlemonth_multiregional_composite_map: 'Integrated Reports',
        statistical_for_tw_weeks: 'Data from the past 12 weeks',
        weekly_case_count: 'Weekly Case Count',
        accu_mon_sel_simultaneously:
            'Accumulated closure count and monthly case count cannot be selected simultaneously.',
        mcc_mm_sr: 'For monthly case count, please select multiple months and a single region.',
        acr_mm_sr:
            'For cumulative closure rate, please select a single month and multiple regions.',
        distribution_Holding: 'Distribution of Holdings',
        hour_response_rate: ' response rate',
        Vehicle_fleet_size: 'Vehicle Fleet Size',
        num_of_cases: 'Number of Cases',
        ratio: 'Ratio',
        techl_inquiry_ratio: ' Technical Inquiry Ratio',
        close_logic: 'Closure rate statistics',
        case_closure_rate: 'Case closure rate',
        technical_closure_rate: 'Technical closure rate',
        doc_stats_scope: 'Statistics Scope of Documents',
    },
    // 德
    deDE: {
        area: 'Bereich',
        // monthly_case_count: 'Monatliche Fallanzahl',
        // monthly_closed: 'Monatlich geschlossen',
        // monthly_closure_rate: 'Monatliche Schließungsrate',
        // accumulated_closure_rate: 'Kumulierte Schließungsrate',
        // case_count_closure_rate:'Fallzahl und Abschlussrate',
        monthly_case_count: 'Monthly Case Count', // 月度案件数
        monthly_closed: 'Monthly Closed', // 月度已关闭
        monthly_closure_rate: 'Monthly Closure Rate', // 月度关闭率
        accumulated_closure_rate: 'Accumulated Closure Rate', // 累计关闭率
        case_count_closure_rate: 'Case Count and Closure Rate',
        Key_market_technical_support_performance_statistics:
            'Key market technical support performance statistics',
        Accumulated_case_count: 'Accumulated case count',
        Accumulated_closure_count: 'Accumulated closure count',
        month_case_count: 'month case ount',
        month_closure_count: 'month closure count',
        five_Day_closure_rate: 'Tagesabschlussquote',
        five_Day_closure_count: 'Five day closure count',
        response_count_24hour: 'response count 24 hour',
        response_rate_24hour: 'response rate 24 hour',
        month_response_rate_24hour: 'response rate 24 hour',
        form_type: 'Typ des Formulars',
        repeat_multiple_choice_msg: 'Monat und Region können nicht gleichzeitig ausgewählt werden!',
        day_closure_rate: 'day closure rate',
        months_case_count: 'anzahl der Fälle pro Monat',
        individually: 'Individually',
        full: 'Full',
        received: 'Received',
        report: 'Report',
        regional_abbreviations: 'Regional Abbreviations',
        name_of_organisation: 'Name Of Organisation',
        form_of_documents: 'Form Of Documents',
        statistical_coverage: 'Statistical Coverage',
        requiredMsg: 'Mandatory information not filled in!',
        singlemonth_multiregional_composite_map: 'Integrierte Berichte',
        statistical_for_tw_weeks: 'Daten der letzten 12 Wochen',
        weekly_case_count: 'Wöchentliche Fallanzahl',
        accu_mon_sel_simultaneously:
            'Kumulative Abschlüsse und monatliche Fallzahlen können nicht gleichzeitig ausgewählt werden.',
        mcc_mm_sr:
            'Für die monatliche Fallzahl wählen Sie bitte mehrere Monate und eine einzelne Region aus.',
        acr_mm_sr:
            'Für die kumulierte Schließungsquote bitte einen Monat und mehrere Regionen auswählen.',
        distribution_Holding: 'Verteilung der Bestände',
        hour_response_rate: ' antwortrate',
        Vehicle_fleet_size: 'Fahrzeugbestand',
        num_of_cases: 'Anzahl der Fälle',
        ratio: 'Verhältnis',
        techl_inquiry_ratio: ' Technisches Anfragenverhältnis',
        close_logic: 'Abschlussrate Statistik',
        case_closure_rate: 'Fallabschlussrate',
        technical_closure_rate: 'Technische Abschlussrate',
        doc_stats_scope: 'Statistikumfang von Belegen',
    },
    // 法
    frFR: {
        area: 'Zone',
        // monthly_case_count: "Nombre mensuel d'affaires",
        // monthly_closed: 'Fermé mensuellement',
        // monthly_closure_rate: 'Taux de fermeture mensuel',
        // accumulated_closure_rate: 'Taux de fermeture cumulé',
        // case_count_closure_rate:'Nombre de cas et taux de fermeture'
        monthly_case_count: 'Monthly Case Count', // 月度案件数
        monthly_closed: 'Monthly Closed', // 月度已关闭
        monthly_closure_rate: 'Monthly Closure Rate', // 月度关闭率
        accumulated_closure_rate: 'Accumulated Closure Rate', // 累计关闭率
        case_count_closure_rate: 'Case Count and Closure Rate',
        Key_market_technical_support_performance_statistics:
            'Key market technical support performance statistics',
        Accumulated_case_count: 'Accumulated case count',
        Accumulated_closure_count: 'Accumulated closure count',
        month_case_count: 'month case ount',
        month_closure_count: 'month closure count',
        five_Day_closure_rate: 'Taux de clôture par jour',
        five_Day_closure_count: 'Five day closure count',
        response_count_24hour: 'response count 24 hour',
        response_rate_24hour: 'response rate 24 hour',
        month_response_rate_24hour: 'response rate 24 hour',
        form_type: 'Type de formulaire',
        repeat_multiple_choice_msg:
            'Le mois et la région ne peuvent pas être sélectionnés simultanément !',
        day_closure_rate: 'day closure rate',
        months_case_count: 'nombre de cas par mois',
        individually: 'Individually',
        full: 'Full',
        received: 'Received',
        report: 'Report',
        regional_abbreviations: 'Regional Abbreviations',
        name_of_organisation: 'Name Of Organisation',
        form_of_documents: 'Form Of Documents',
        statistical_coverage: 'Statistical Coverage',
        requiredMsg: 'Mandatory information not filled in!',
        singlemonth_multiregional_composite_map: 'Rapports intégrés',
        statistical_for_tw_weeks: 'Données des 12 dernières semaines',
        weekly_case_count: 'Nombre de cas hebdomadaires',
        accu_mon_sel_simultaneously:
            'Le nombre de fermetures accumulées et le nombre de cas mensuels ne peuvent pas être sélectionnés simultanément.',
        mcc_mm_sr:
            'Pour le nombre de cas mensuels, veuillez sélectionner plusieurs mois et une seule région.',
        acr_mm_sr:
            'Pour le taux de clôture cumulé, veuillez sélectionner un mois et plusieurs régions.',
        distribution_Holding: 'Répartition des stocks',
        hour_response_rate: ' taux de réponse',
        Vehicle_fleet_size: 'Parc de véhicules',
        num_of_cases: 'Nombre de cas',
        ratio: 'Ratio',
        techl_inquiry_ratio: ' Ratio des demandes techniques',
        close_logic: 'Statistiques du taux de clôture',
        case_closure_rate: 'Taux de clôture des cas',
        technical_closure_rate: 'Taux de clôture technique',
        doc_stats_scope: 'Portée statistique des documents',
    },
    // 意大利
    itIT: {
        area: 'Area',
        // monthly_case_count: 'Numero mensile di casi',
        // monthly_closed: 'Chiuso mensilmente',
        // monthly_closure_rate: 'Tasso di chiusura mensile',
        // accumulated_closure_rate: 'Tasso di chiusura cumulativo',
        // case_count_closure_rate:'Numero di casi e tasso di chiusura'
        monthly_case_count: 'Monthly Case Count', // 月度案件数
        monthly_closed: 'Monthly Closed', // 月度已关闭
        monthly_closure_rate: 'Monthly Closure Rate', // 月度关闭率
        accumulated_closure_rate: 'Accumulated Closure Rate', // 累计关闭率
        case_count_closure_rate: 'Case Count and Closure Rate',
        Key_market_technical_support_performance_statistics:
            'Key market technical support performance statistics',
        Accumulated_case_count: 'Accumulated case count',
        Accumulated_closure_count: 'Accumulated closure count',
        month_case_count: 'month case ount',
        month_closure_count: 'month closure count',
        five_Day_closure_rate: 'Tasso di chiusura giornaliero',
        five_Day_closure_count: 'Five day closure count',
        response_count_24hour: 'response count 24 hour',
        response_rate_24hour: 'response rate 24 hour',
        month_response_rate_24hour: 'response rate 24 hour',
        form_type: 'Tipo di modulo',
        repeat_multiple_choice_msg:
            'Il mese e la regione non possono essere selezionati contemporaneamente!',
        day_closure_rate: 'day closure rate',
        months_case_count: 'numero di casi al mese',
        individually: 'Individually',
        full: 'Full',
        received: 'Received',
        report: 'Report',
        regional_abbreviations: 'Regional Abbreviations',
        name_of_organisation: 'Name Of Organisation',
        form_of_documents: 'Form Of Documents',
        statistical_coverage: 'Statistical Coverage',
        requiredMsg: 'Mandatory information not filled in!',
        singlemonth_multiregional_composite_map: 'Report integrati',
        statistical_for_tw_weeks: 'Dati delle ultime 12 settimane',
        weekly_case_count: 'Numero di casi settimanali',
        accu_mon_sel_simultaneously:
            'Il conteggio delle chiusure accumulate e il conteggio dei casi mensili non possono essere selezionati simultaneamente.',
        mcc_mm_sr:
            'Per il conteggio dei casi mensili, si prega di selezionare più mesi e una sola regione.',
        acr_mm_sr: 'Per il tasso di chiusura cumulativo, selezionare un mese e più aree.',
        distribution_Holding: 'Distribuzione delle scorte',
        hour_response_rate: ' tasso di risposta',
        Vehicle_fleet_size: 'Flotta di veicoli',
        num_of_cases: 'Numero di casi',
        ratio: 'Rapporto',
        techl_inquiry_ratio: ' Rapporto delle richieste tecniche',
        close_logic: 'Statistiche del tasso di chiusura',
        case_closure_rate: 'Tasso di chiusura dei casi',
        technical_closure_rate: 'Tasso di chiusura tecnica',
        doc_stats_scope: 'Ambito statistico dei documenti',
    },
    // 荷兰
    nlNL: {
        area: 'Gebied',
        // monthly_case_count: 'Maandelijks aantal gevallen',
        // monthly_closed: 'Maandelijks gesloten',
        // monthly_closure_rate: 'Maandelijks sluitingspercentage',
        // accumulated_closure_rate: 'Opgeslagen sluitingspercentage',
        // case_count_closure_rate:'Aantal gevallen en sluitingspercentage'
        monthly_case_count: 'Monthly Case Count', // 月度案件数
        monthly_closed: 'Monthly Closed', // 月度已关闭
        monthly_closure_rate: 'Monthly Closure Rate', // 月度关闭率
        accumulated_closure_rate: 'Accumulated Closure Rate', // 累计关闭率
        case_count_closure_rate: 'Case Count and Closure Rate',
        Key_market_technical_support_performance_statistics:
            'Key market technical support performance statistics',
        Accumulated_case_count: 'Accumulated case count',
        Accumulated_closure_count: 'Accumulated closure count',
        month_case_count: 'month case ount',
        month_closure_count: 'month closure count',
        five_Day_closure_rate: 'Dagelijkse sluitingspercentage',
        five_Day_closure_count: 'Five day closure count',
        response_count_24hour: 'response count 24 hour',
        response_rate_24hour: 'response rate 24 hour',
        month_response_rate_24hour: 'response rate 24 hour',
        form_type: 'Type formulier',
        repeat_multiple_choice_msg:
            'Maand en regio kunnen niet tegelijkertijd worden geselecteerd!',
        day_closure_rate: 'day closure rate',
        months_case_count: 'aantal gevallen per maand',
        individually: 'Individually',
        full: 'Full',
        received: 'Received',
        report: 'Report',
        regional_abbreviations: 'Regional Abbreviations',
        name_of_organisation: 'Name Of Organisation',
        form_of_documents: 'Form Of Documents',
        statistical_coverage: 'Statistical Coverage',
        requiredMsg: 'Mandatory information not filled in!',
        singlemonth_multiregional_composite_map: 'Geïntegreerde rapporten',
        statistical_for_tw_weeks: 'Gegevens van de afgelopen 12 weken',
        weekly_case_count: 'Wekelijkse Zaakaantal',
        accu_mon_sel_simultaneously:
            'De cumulatieve afsluitingen en het maandelijkse aantal zaken kunnen niet tegelijkertijd worden geselecteerd.',
        mcc_mm_sr:
            'Voor het maandelijkse aantal gevallen selecteer alstublieft meerdere maanden en één regio.',
        acr_mm_sr:
            'Selecteer één maand en meerdere regio’s voor het cumulatieve sluitingspercentage.',
        distribution_Holding: 'Verdeling van de voorraden',
        hour_response_rate: ' responsie-rate',
        Vehicle_fleet_size: 'Voertuigparkgrootte',
        num_of_cases: 'Aantal zaken',
        ratio: 'Verhouding',
        techl_inquiry_ratio: ' Technisch informatieverzoek verhouding',
        close_logic: 'Sluitingspercentage statistieken',
        case_closure_rate: 'Case sluitingspercentage',
        technical_closure_rate: 'Technisch sluitingspercentage',
        doc_stats_scope: 'Statistiekscope van documenten',
    },
    // 越南
    viVN: {
        area: 'Khu vực',
        // monthly_case_count: 'Số vụ hàng tháng',
        // monthly_closed: 'Hàng tháng đã đóng',
        // monthly_closure_rate: 'Tỷ lệ đóng hàng tháng',
        // accumulated_closure_rate: 'Tỷ lệ đóng tích lũy',
        // case_count_closure_rate:'Số vụ và Tỷ lệ Đóng cửa'
        monthly_case_count: 'Monthly Case Count', // 月度案件数
        monthly_closed: 'Monthly Closed', // 月度已关闭
        monthly_closure_rate: 'Monthly Closure Rate', // 月度关闭率
        accumulated_closure_rate: 'Accumulated Closure Rate', // 累计关闭率
        case_count_closure_rate: 'Case Count and Closure Rate',
        Key_market_technical_support_performance_statistics:
            'Key market technical support performance statistics',
        Accumulated_case_count: 'Accumulated case count',
        Accumulated_closure_count: 'Accumulated closure count',
        month_case_count: 'month case ount',
        month_closure_count: 'month closure count',
        five_Day_closure_rate: 'Tỷ lệ đóng theo ngày',
        five_Day_closure_count: 'Five day closure count',
        response_count_24hour: 'response count 24 hour',
        response_rate_24hour: 'response rate 24 hour',
        month_response_rate_24hour: 'response rate 24 hour',
        form_type: 'Loại Form',
        repeat_multiple_choice_msg: 'Tháng và khu vực không thể đồng thời chọn nhiều!',
        day_closure_rate: 'day closure rate',
        months_case_count: 'Số vụ án hàng tháng',
        individually: 'Individually',
        full: 'Full',
        received: 'Received',
        report: 'Report',
        regional_abbreviations: 'Regional Abbreviations',
        name_of_organisation: 'Name Of Organisation',
        form_of_documents: 'Form Of Documents',
        statistical_coverage: 'Statistical Coverage',
        requiredMsg: 'Mandatory information not filled in!',
        singlemonth_multiregional_composite_map: 'Báo cáo tích hợp',
        statistical_for_tw_weeks: 'Dữ liệu trong 12 tuần qua',
        weekly_case_count: 'Số lượng vụ án hàng tuần',
        accu_mon_sel_simultaneously:
            'Số lượng đóng cửa tích lũy và số lượng vụ việc hàng tháng không thể được chọn đồng thời.',
        mcc_mm_sr:
            'Đối với số lượng vụ việc hàng tháng, vui lòng chọn nhiều tháng và một khu vực duy nhất.',
        acr_mm_sr: 'Để xem tỷ lệ đóng tích lũy, vui lòng chọn một tháng và nhiều khu vực.',
        distribution_Holding: 'Phân bố lượng dự trữ',
        hour_response_rate: ' tỷ lệ phản hồi',
        Vehicle_fleet_size: 'Quy mô đội xe',
        num_of_cases: 'Số lượng trường hợp',
        ratio: 'Tỷ lệ',
        techl_inquiry_ratio: ' Tỷ lệ yêu cầu kỹ thuật',
        close_logic: 'Thống kê tỷ lệ đóng',
        case_closure_rate: 'Tỷ lệ đóng trường hợp',
        technical_closure_rate: 'Tỷ lệ đóng kỹ thuật',
        doc_stats_scope: 'Phạm vi thống kê của chứng từ',
    },
    // 西班牙
    esES: {
        area: 'Área',
        // monthly_case_count: 'Número de casos mensuales',
        // monthly_closed: 'Cerrados mensuales',
        // monthly_closure_rate: 'Tasa de cierre mensual',
        // accumulated_closure_rate: 'Tasa de cierre acumulada',
        // case_count_closure_rate:'Número de casos y tasa de cierre'
        monthly_case_count: 'Monthly Case Count', // 月度案件数
        monthly_closed: 'Monthly Closed', // 月度已关闭
        monthly_closure_rate: 'Monthly Closure Rate', // 月度关闭率
        accumulated_closure_rate: 'Accumulated Closure Rate', // 累计关闭率
        case_count_closure_rate: 'Case Count and Closure Rate',
        Key_market_technical_support_performance_statistics:
            'Key market technical support performance statistics',
        Accumulated_case_count: 'Accumulated case count',
        Accumulated_closure_count: 'Accumulated closure count',
        month_case_count: 'month case ount',
        month_closure_count: 'month closure count',
        five_Day_closure_rate: 'Tasa de cierre diaria',
        five_Day_closure_count: 'Five day closure count',
        response_count_24hour: 'response count 24 hour',
        response_rate_24hour: 'response rate 24 hour',
        month_response_rate_24hour: 'response rate 24 hour',
        form_type: 'Tipo de formulario',
        repeat_multiple_choice_msg: 'El mes y la región no se pueden seleccionar simultáneamente.!',
        day_closure_rate: 'day closure rate',
        months_case_count: 'número de casos por mes',
        individually: 'Individually',
        full: 'Full',
        received: 'Received',
        report: 'Report',
        regional_abbreviations: 'Regional Abbreviations',
        name_of_organisation: 'Name Of Organisation',
        form_of_documents: 'Form Of Documents',
        statistical_coverage: 'Statistical Coverage',
        requiredMsg: 'Mandatory information not filled in!',
        singlemonth_multiregional_composite_map: 'Informes integrados',
        statistical_for_tw_weeks: 'Datos de las últimas 12 semanas',
        weekly_case_count: 'Número de casos semanal',
        accu_mon_sel_simultaneously:
            'El recuento acumulado de cierres y el recuento de casos mensuales no pueden seleccionarse simultáneamente.',
        mcc_mm_sr:
            'Para el recuento de casos mensuales, por favor seleccione varios meses y una sola región.',
        acr_mm_sr: 'Para la tasa de cierre acumulada, seleccione un mes y varias regiones.',
        distribution_Holding: 'Distribución de existencias',
        hour_response_rate: ' tasa de respuesta',
        Vehicle_fleet_size: 'Flota de vehículos',
        num_of_cases: 'Número de casos',
        ratio: 'Proporción',
        techl_inquiry_ratio: ' Proporción de consultas técnicas',
        close_logic: 'Estadísticas de la tasa de cierre',
        case_closure_rate: 'Tasa de cierre de casos',
        technical_closure_rate: 'Tasa de cierre técnico',
        doc_stats_scope: 'Alcance estadístico de los documentos',
    },
    // 葡萄牙
    ptBR: {
        area: 'Área',
        // monthly_case_count: 'Contagem mensal de casos',
        // monthly_closed: 'Fechados mensalmente',
        // monthly_closure_rate: 'Taxa de fechamento mensal',
        // accumulated_closure_rate: 'Taxa de fechamento acumulado',
        // case_count_closure_rate:'Contagem de Casos e Taxa de Encerramento'
        monthly_case_count: 'Monthly Case Count', // 月度案件数
        monthly_closed: 'Monthly Closed', // 月度已关闭
        monthly_closure_rate: 'Monthly Closure Rate', // 月度关闭率
        accumulated_closure_rate: 'Accumulated Closure Rate', // 累计关闭率
        case_count_closure_rate: 'Case Count and Closure Rate',
        Key_market_technical_support_performance_statistics:
            'Key market technical support performance statistics',
        Accumulated_case_count: 'Accumulated case count',
        Accumulated_closure_count: 'Accumulated closure count',
        month_case_count: 'month case ount',
        month_closure_count: 'month closure count',
        five_Day_closure_rate: 'Taxa de fechamento diária',
        five_Day_closure_count: 'Five day closure count',
        response_count_24hour: 'response count 24 hour',
        response_rate_24hour: 'response rate 24 hour',
        month_response_rate_24hour: 'response rate 24 hour',
        form_type: 'Tipo de formulário',
        repeat_multiple_choice_msg:
            'O mês e a região não podem ser multi-seleccionados ao mesmo tempo!',
        day_closure_rate: 'day closure rate',
        months_case_count: 'número de casos por mês',
        individually: 'Individually',
        full: 'Full',
        received: 'Received',
        report: 'Report',
        regional_abbreviations: 'Regional Abbreviations',
        name_of_organisation: 'Name Of Organisation',
        form_of_documents: 'Form Of Documents',
        statistical_coverage: 'Statistical Coverage',
        requiredMsg: 'Mandatory information not filled in!',
        singlemonth_multiregional_composite_map: 'Relatórios integrados',
        statistical_for_tw_weeks: 'Dados das últimas 12 semanas',
        weekly_case_count: 'Contagem de casos semanal',
        accu_mon_sel_simultaneously:
            'O número acumulado de fechamentos e o número de casos mensais não podem ser selecionados simultaneamente.',
        mcc_mm_sr:
            'Para o número de casos mensais, por favor, selecione vários meses e uma única região.',
        acr_mm_sr: 'Para a taxa de encerramento acumulada, selecione um mês e várias regiões.',
        distribution_Holding: 'Distribuição de estoques',
        hour_response_rate: ' taxa de resposta',
        Vehicle_fleet_size: 'Frota de veículos',
        num_of_cases: 'Número de casos',
        ratio: 'Proporção',
        techl_inquiry_ratio: ' Proporção de consultas técnicas',
        close_logic: 'Estatísticas da taxa de fechamento',
        case_closure_rate: 'Taxa de fechamento de casos',
        technical_closure_rate: 'Taxa de fechamento técnico',
        doc_stats_scope: 'Escopo estatístico dos documentos',
    },
    // 波兰
    plPL: {
        area: 'Obszar',
        // monthly_case_count: 'Liczba przypadków miesięcznie',
        // monthly_closed: 'Zamknięte miesięcznie',
        // monthly_closure_rate: 'Współczynnik zamknięcia miesięcznego',
        // accumulated_closure_rate: 'Skumulowany współczynnik zamknięcia',
        // case_count_closure_rate:'Liczba przypadków i wskaźnik zamknięcia'
        monthly_case_count: 'Monthly Case Count', // 月度案件数
        monthly_closed: 'Monthly Closed', // 月度已关闭
        monthly_closure_rate: 'Monthly Closure Rate', // 月度关闭率
        accumulated_closure_rate: 'Accumulated Closure Rate', // 累计关闭率
        case_count_closure_rate: 'Case Count and Closure Rate',
        Key_market_technical_support_performance_statistics:
            'Key market technical support performance statistics',
        Accumulated_case_count: 'Accumulated case count',
        Accumulated_closure_count: 'Accumulated closure count',
        month_case_count: 'month case ount',
        month_closure_count: 'month closure count',
        five_Day_closure_rate: 'Dzienny wskaźnik zamknięcia',
        five_Day_closure_count: 'Five day closure count',
        response_count_24hour: 'response count 24 hour',
        response_rate_24hour: 'response rate 24 hour',
        month_response_rate_24hour: 'response rate 24 hour',
        form_type: 'Typ formularza',
        repeat_multiple_choice_msg: 'Miesiąc i region nie mogą być wybrane jednocześnie!',
        day_closure_rate: 'day closure rate',
        months_case_count: 'liczba przypadków na miesiąc',
        individually: 'Individually',
        full: 'Full',
        received: 'Received',
        report: 'Report',
        regional_abbreviations: 'Regional Abbreviations',
        name_of_organisation: 'Name Of Organisation',
        form_of_documents: 'Form Of Documents',
        statistical_coverage: 'Statistical Coverage',
        requiredMsg: 'Mandatory information not filled in!',
        singlemonth_multiregional_composite_map: 'Zintegrowane raporty',
        statistical_for_tw_weeks: 'Dane z ostatnich 12 tygodni',
        weekly_case_count: 'Liczba spraw tygodniowych',
        accu_mon_sel_simultaneously:
            'Liczba zamknięć skumulowanych i liczba spraw miesięcznych nie mogą być wybrane jednocześnie.',
        mcc_mm_sr: 'Dla liczby spraw miesięcznych proszę wybrać kilka miesięcy i jeden region.',
        acr_mm_sr:
            'Aby wyświetlić skumulowany wskaźnik zamknięcia, wybierz jeden miesiąc i wiele regionów.',
        distribution_Holding: 'Dystrybucja zapasów',
        hour_response_rate: ' wskaźnik odpowiedzi',
        Vehicle_fleet_size: 'Flota pojazdów',
        num_of_cases: 'Liczba spraw',
        ratio: 'Stosunek',
        techl_inquiry_ratio: ' Wskaźnik zapytań technicznych',
        close_logic: 'Statystyka wskaźnika zamknięcia',
        case_closure_rate: 'Wskaźnik zamknięcia spraw',
        technical_closure_rate: 'Wskaźnik zamknięcia technicznego',
        doc_stats_scope: 'Zakres statystyki dokumentów',
    },
    // 土耳其
    trTR: {
        area: 'Alan',
        // monthly_case_count: 'Aylık Vaka Sayısı',
        // monthly_closed: 'Aylık Kapatılan',
        // monthly_closure_rate: 'Aylık Kapanma Oranı',
        // accumulated_closure_rate: 'Birikmiş Kapanma Oranı',
        // case_count_closure_rate:'Vaka Sayısı ve Kapanış Oranı'
        monthly_case_count: 'Monthly Case Count', // 月度案件数
        monthly_closed: 'Monthly Closed', // 月度已关闭
        monthly_closure_rate: 'Monthly Closure Rate', // 月度关闭率
        accumulated_closure_rate: 'Accumulated Closure Rate', // 累计关闭率
        case_count_closure_rate: 'Case Count and Closure Rate',
        Key_market_technical_support_performance_statistics:
            'Key market technical support performance statistics',
        Accumulated_case_count: 'Accumulated case count',
        Accumulated_closure_count: 'Accumulated closure count',
        month_case_count: 'month case ount',
        month_closure_count: 'month closure count',
        five_Day_closure_rate: 'Günlük kapanış oranı',
        five_Day_closure_count: 'Five day closure count',
        response_count_24hour: 'response count 24 hour',
        response_rate_24hour: 'response rate 24 hour',
        month_response_rate_24hour: 'response rate 24 hour',
        form_type: 'Form türü',
        repeat_multiple_choice_msg: 'Ay ve bölge aynı anda birden fazla seçilemez!',
        day_closure_rate: 'day closure rate',
        months_case_count: 'aylık vaka sayısı',
        individually: 'Individually',
        full: 'Full',
        received: 'Received',
        report: 'Report',
        regional_abbreviations: 'Regional Abbreviations',
        name_of_organisation: 'Name Of Organisation',
        form_of_documents: 'Form Of Documents',
        statistical_coverage: 'Statistical Coverage',
        requiredMsg: 'Mandatory information not filled in!',
        singlemonth_multiregional_composite_map: 'Entegre Raporlar',
        statistical_for_tw_weeks: 'Son 12 haftanın verileri',
        weekly_case_count: 'Haftalık Dava Sayısı',
        accu_mon_sel_simultaneously:
            'Kümülatif kapanış sayısı ve aylık dava sayısı aynı anda seçilemez.',
        mcc_mm_sr: 'Aylık dava sayısı için lütfen birden fazla ay ve tek bir bölge seçin.',
        acr_mm_sr: 'Kümülatif kapanma oranı için lütfen tek bir ay ve birden fazla bölge seçin.',
        distribution_Holding: 'Stok dağılımı',
        hour_response_rate: ' yanıt oranı',
        Vehicle_fleet_size: 'Araç filosu büyüklüğü',
        num_of_cases: 'Vaka sayısı',
        ratio: 'Oran',
        techl_inquiry_ratio: ' Teknik sorgulama oranı',
        close_logic: 'Kapanma oranı istatistikleri',
        case_closure_rate: 'Vaka kapanma oranı',
        technical_closure_rate: 'Teknik kapanma oranı',
        doc_stats_scope: 'Belge İstatistikleri Aralığı',
    },
    // 捷克语
    csCZ: {
        area: 'Oblast',
        monthly_case_count: 'Měsíční počet případů',
        monthly_closed: 'Měsíčně uzavřeno',
        monthly_closure_rate: 'Měsíční míra uzavření',
        accumulated_closure_rate: 'Akumulovaná míra uzavření',
        case_count_closure_rate: 'Počet případů a míra uzavření',
        Key_market_technical_support_performance_statistics:
            'Key market technical support performance statistics',
        Accumulated_case_count: 'Akumulovaný počet případů',
        Accumulated_closure_count: 'Akumulovaný počet uzavření',
        month_case_count: 'měsíční počet případů',
        month_closure_count: 'počet uzavřených případů za měsíc',
        five_Day_closure_rate: 'Denní míra uzavření',
        response_count_24hour: 'počet odpovědí 24 hodin',
        five_Day_closure_count: 'počet uzavřených případů za 5 dní',
        response_rate_24hour: 'rychlost odezvy 24 hodin',
        month_response_rate_24hour: 'měsíční rychlost odezvy 24 hodin',
        form_type: 'Typ formuláře',
        repeat_multiple_choice_msg: 'Měsíc a oblast nelze vybrat současně vícekrát!',
        day_closure_rate: 'Míra uzavření za dní',
        months_case_count: 'počet případů za měsíc',
        individually: 'Individually',
        full: 'Full',
        received: 'Received',
        report: 'Report',
        regional_abbreviations: 'Regional Abbreviations',
        name_of_organisation: 'Name Of Organisation',
        form_of_documents: 'Form Of Documents',
        statistical_coverage: 'Statistical Coverage',
        requiredMsg: 'Mandatory information not filled in!',
        singlemonth_multiregional_composite_map: 'Integrované zprávy',
        statistical_for_tw_weeks: 'Data za posledních 12 týdnů',
        weekly_case_count: 'Týdenní počet případů',
        accu_mon_sel_simultaneously:
            'Kumulovaný počet uzávěrů a měsíční počet případů nemohou být vybrány současně.',
        mcc_mm_sr: 'Pro měsíční počet případů vyberte prosím více měsíců a jednu oblast.',
        acr_mm_sr: 'Pro kumulativní míru uzavření vyberte prosím jeden měsíc a více oblastí.',
        distribution_Holding: 'Rozdělení zásob',
        hour_response_rate: ' míra odpovědí',
        Vehicle_fleet_size: 'Počet vozidel ve flotile',
        num_of_cases: 'Počet případů',
        ratio: 'Poměr',
        techl_inquiry_ratio: ' Poměr technických dotazů',
        close_logic: 'Statistiky míry uzavření',
        case_closure_rate: 'Míra uzavření případů',
        technical_closure_rate: 'Míra technického uzavření',
        doc_stats_scope: 'Statistický rozsah dokladů',
    },
    // 匈牙利语
    huHU: {
        area: 'Terület',
        monthly_case_count: 'Havi esetszám',
        monthly_closed: 'Havi lezárt',
        monthly_closure_rate: 'Havi lezárási arány',
        accumulated_closure_rate: 'Összesített lezárási arány',
        case_count_closure_rate: 'Esetszám és lezárási arány',
        Key_market_technical_support_performance_statistics:
            'Fő piac műszaki támogatásának teljesítménystatisztikái',
        Accumulated_case_count: 'Összesített esetszám',
        Accumulated_closure_count: 'Összesített lezárási szám',
        month_case_count: 'Havi esetszám',
        month_closure_count: 'Havi lezárási szám',
        five_Day_closure_rate: 'Napi zárási arány',
        five_Day_closure_count: 'Ötnapos lezárási szám',
        response_count_24hour: '24 órás reakciók száma',
        response_rate_24hour: '24 órás reakciók aránya',
        month_response_rate_24hour: 'Havi 24 órás reakciók aránya',
        form_type: 'Űrlap típusa',
        repeat_multiple_choice_msg: 'A hónap és a terület nem választható egyszerre!',
        day_closure_rate: 'napi zárási arány',
        months_case_count: 'az esetek száma havonta',
        individually: 'Individually',
        full: 'Full',
        received: 'Received',
        report: 'Report',
        regional_abbreviations: 'Regional Abbreviations',
        name_of_organisation: 'Name Of Organisation',
        form_of_documents: 'Form Of Documents',
        statistical_coverage: 'Statistical Coverage',
        requiredMsg: 'Mandatory information not filled in!',
        singlemonth_multiregional_composite_map: 'Integrált jelentések',
        statistical_for_tw_weeks: 'Az elmúlt 12 hét adatai',
        weekly_case_count: 'Heti ügyek száma',
        accu_mon_sel_simultaneously:
            'A felhalmozott zárások száma és a havi esetszám nem választható egyszerre.',
        mcc_mm_sr: 'Havi esetszámhoz kérjük, válasszon több hónapot és egyetlen régiót.',
        acr_mm_sr: 'A kumulatív lezárási arányhoz válasszon egy hónapot és több régiót.',
        distribution_Holding: 'Készletek eloszlása',
        hour_response_rate: ' válaszarány',
        Vehicle_fleet_size: 'Járműflotta mérete',
        num_of_cases: 'Esetek száma',
        ratio: 'Arány',
        techl_inquiry_ratio: ' Műszaki kérdések aránya',
        close_logic: 'Záródíjak statisztikája',
        case_closure_rate: 'Esetek bezárásának aránya',
        technical_closure_rate: 'Technikai bezárás aránya',
        doc_stats_scope: 'Dokumentumstatisztikai tartomány',
    },
    // 俄罗斯语
    ruRU: {
        area: 'Область',
        monthly_case_count: 'Ежемесячное количество дел',
        monthly_closed: 'Ежемесячно закрыто',
        monthly_closure_rate: 'Ежемесячный коэффициент закрытия',
        accumulated_closure_rate: 'Накопленный коэффициент закрытия',
        case_count_closure_rate: 'Коэффициент закрытия по количеству дел',
        Key_market_technical_support_performance_statistics:
            'Статистика производительности технической поддержки ключевых рынков',
        Accumulated_case_count: 'Накопленное количество дел',
        Accumulated_closure_count: 'Накопленное количество закрытий',
        month_case_count: 'Месячное количество дел',
        month_closure_count: 'Месячное количество закрытий',
        five_Day_closure_rate: 'Ежедневный коэффициент закрытия',
        five_Day_closure_count: 'Количество закрытий за 5 дней',
        response_count_24hour: 'Количество ответов за 24 часа',
        response_rate_24hour: 'Коэффициент ответов за 24 часа',
        month_response_rate_24hour: 'Коэффициент ответов за 24 часа',
        form_type: 'Тип формы',
        repeat_multiple_choice_msg: 'Месяц и область не могут быть выбраны одновременно!',
        day_closure_rate: 'Коэффициент закрытия за день',
        months_case_count: 'Ежемесячное количество дел',
        individually: 'Individually',
        full: 'Full',
        received: 'Received',
        report: 'Report',
        regional_abbreviations: 'Regional Abbreviations',
        name_of_organisation: 'Name Of Organisation',
        form_of_documents: 'Form Of Documents',
        statistical_coverage: 'Statistical Coverage',
        requiredMsg: 'Mandatory information not filled in!',
        singlemonth_multiregional_composite_map: 'Интегрированные отчеты',
        statistical_for_tw_weeks: 'Данные за последние 12 недель',
        weekly_case_count: 'Еженедельное количество дел',
        accu_mon_sel_simultaneously:
            'Суммарное количество закрытий и количество дел за месяц не могут быть выбраны одновременно.',
        mcc_mm_sr:
            'Для количества дел за месяц, пожалуйста, выберите несколько месяцев и один регион.',
        acr_mm_sr:
            'Для отображения накопленного коэффициента закрытия выберите один месяц и несколько регионов.',
        distribution_Holding: 'Распределение запасов',
        hour_response_rate: ' Процент ответов',
        Vehicle_fleet_size: 'Размер автопарка',
        num_of_cases: 'Количество случаев',
        ratio: 'Соотношение',
        techl_inquiry_ratio: ' Соотношение технических запросов',
        close_logic: 'Статистика показателя закрытия',
        case_closure_rate: 'Показатель закрытия случаев',
        technical_closure_rate: 'Показатель технического закрытия',
        doc_stats_scope: 'Статистический диапазон документов',
    },
    // 沙特阿拉伯
    arSA: {
        area: 'المنطقة',
        monthly_case_count: 'عدد الحالات الشهرية',
        monthly_closed: 'المغلقة شهريًا',
        monthly_closure_rate: 'معدل الإغلاق الشهري',
        accumulated_closure_rate: 'معدل الإغلاق التراكمي',
        case_count_closure_rate: 'عدد الحالات ومعدل الإغلاق',
        Key_market_technical_support_performance_statistics:
            'إحصائيات أداء الدعم الفني في الأسواق الرئيسية',
        Accumulated_case_count: 'إجمالي عدد الحالات',
        Accumulated_closure_count: 'إجمالي عدد المغلقة',
        month_case_count: 'عدد الحالات الشهرية',
        month_closure_count: 'عدد المغلقة شهريًا',
        five_Day_closure_rate: 'معدل الإغلاق خلال 5 أيام',
        five_Day_closure_count: 'عدد المغلقة خلال 5 أيام',
        response_count_24hour: 'عدد الردود خلال 24 ساعة',
        response_rate_24hour: 'معدل الرد خلال 24 ساعة',
        month_response_rate_24hour: 'معدل الرد خلال 24 ساعة',
        form_type: 'نوع النموذج',
        repeat_multiple_choice_msg: 'لا يمكن اختيار أكثر من شهر ومنطقة في نفس الوقت!',
        day_closure_rate: 'معدل الإغلاق اليومي',
        months_case_count: 'عدد الحالات الشهرية',
        individually: 'فردي',
        full: 'الكل',
        received: 'مستلم',
        report: 'تم الإبلاغ',
        regional_abbreviations: 'اختصارات المناطق',
        name_of_organisation: 'اسم المنظمة',
        form_of_documents: 'شكل المستندات',
        statistical_coverage: 'نطاق الإحصاء',
        requiredMsg: 'لم يتم تعبئة المعلومات المطلوبة!',
        singlemonth_multiregional_composite_map: 'تقرير مدمج',
        statistical_for_tw_weeks: 'بيانات آخر 12 أسبوعًا',
        weekly_case_count: 'عدد الحالات الأسبوعية',
        accu_mon_sel_simultaneously:
            'لا يمكن اختيار "عدد الحالات الشهرية" و"معدل الإغلاق التراكمي" معًا!',
        mcc_mm_sr: 'يرجى اختيار عدة أشهر ومنطقة واحدة لـ "عدد الحالات الشهرية"',
        acr_mm_sr: 'يرجى اختيار شهر واحد وعدة مناطق لـ "معدل الإغلاق التراكمي"',
        distribution_Holding: 'توزيع الحصة السوقية',
        hour_response_rate: 'معدل الرد',
        Vehicle_fleet_size: 'حجم الأسطول حسب الطراز',
        num_of_cases: 'عدد الحالات',
        ratio: 'النسبة',
        techl_inquiry_ratio: 'نسبة الاستفسارات التقنية',
        close_logic: 'إحصاء معدل الإغلاق',
        case_closure_rate: 'معدل إغلاق الحالات',
        technical_closure_rate: 'معدل الإغلاق التقني',
        doc_stats_scope: 'نطاق إحصاء المستندات',
    },
    // 保加利亚
    bgBG: {
        area: 'Регион',
        monthly_case_count: 'Брой случаи месечно',
        monthly_closed: 'Месечно затворени',
        monthly_closure_rate: 'Месечен процент затваряне',
        accumulated_closure_rate: 'Натрупан процент затваряне',
        case_count_closure_rate: 'Брой случаи и процент затваряне',
        Key_market_technical_support_performance_statistics:
            'Статистика за представянето на техническата поддръжка в ключовите пазари',
        Accumulated_case_count: 'Натрупан брой случаи',
        Accumulated_closure_count: 'Натрупан брой затворени',
        month_case_count: 'Брой случаи за месец',
        month_closure_count: 'Брой затворени за месец',
        five_Day_closure_rate: 'Процент затваряне за 5 дни',
        five_Day_closure_count: 'Брой затворени за 5 дни',
        response_count_24hour: 'Брой отговори в рамките на 24 часа',
        response_rate_24hour: 'Процент отговори в рамките на 24 часа',
        month_response_rate_24hour: 'Процент отговори в рамките на 24 часа',
        form_type: 'Тип формуляр',
        repeat_multiple_choice_msg:
            'Не може едновременно да изберете повече от един месец и регион!',
        day_closure_rate: 'Дневен процент затваряне',
        months_case_count: 'Брой случаи месечно',
        individually: 'Индивидуално',
        full: 'Всички',
        received: 'Получено',
        report: 'Докладвано',
        regional_abbreviations: 'Съкращения на региони',
        name_of_organisation: 'Име на организацията',
        form_of_documents: 'Форма на документите',
        statistical_coverage: 'Обхват на статистиката',
        requiredMsg: 'Липсва задължителна информация!',
        singlemonth_multiregional_composite_map: 'Комбиниран доклад',
        statistical_for_tw_weeks: 'Данни за последните 12 седмици',
        weekly_case_count: 'Брой случаи седмично',
        accu_mon_sel_simultaneously:
            '„Брой случаи месечно“ и „Натрупан процент затваряне“ не могат да бъдат избрани едновременно!',
        mcc_mm_sr: 'За „Брой случаи месечно“ изберете няколко месеца и един регион',
        acr_mm_sr: 'За „Натрупан процент затваряне“ изберете един месец и няколко региона',
        distribution_Holding: 'Разпределение на наличностите',
        hour_response_rate: 'Процент отговори',
        Vehicle_fleet_size: 'Размер на автомобилния парк по модел',
        num_of_cases: 'Брой случаи',
        ratio: 'Съотношение',
        techl_inquiry_ratio: 'Съотношение на технически запитвания',
        close_logic: 'Статистика на процента на затваряне',
        case_closure_rate: 'Процент на затваряне на случаи',
        technical_closure_rate: 'Технически процент на затваряне',
        doc_stats_scope: 'Обхват на статистиката за документи',
    },
    // 丹麦语
    daDK: {
        area: 'Område',
        monthly_case_count: 'Månedlige sager',
        monthly_closed: 'Månedligt lukkede',
        monthly_closure_rate: 'Månedlig lukningsrate',
        accumulated_closure_rate: 'Akkumuleret lukningsrate',
        case_count_closure_rate: 'Antal sager og lukningsrate',
        Key_market_technical_support_performance_statistics:
            'Statistik over teknisk supportydelse i nøglemarkeder',
        Accumulated_case_count: 'Akkumuleret antal sager',
        Accumulated_closure_count: 'Akkumuleret antal lukkede sager',
        month_case_count: 'Sager denne måned',
        month_closure_count: 'Lukkede sager denne måned',
        five_Day_closure_rate: '5-dages lukningsrate',
        five_Day_closure_count: 'Antal lukket inden for 5 dage',
        response_count_24hour: 'Antal svar inden for 24 timer',
        response_rate_24hour: 'Svarprocent inden for 24 timer',
        month_response_rate_24hour: 'Svarprocent inden for 24 timer',
        form_type: 'Formulartype',
        repeat_multiple_choice_msg: 'Du kan ikke vælge flere måneder og områder samtidig!',
        day_closure_rate: 'Dagslukningsrate',
        months_case_count: 'Månedlige sager',
        individually: 'Enkeltvis',
        full: 'Alle',
        received: 'Modtaget',
        report: 'Rapporteret',
        regional_abbreviations: 'Regionsforkortelser',
        name_of_organisation: 'Organisationsnavn',
        form_of_documents: 'Dokumentformat',
        statistical_coverage: 'Statistikomfang',
        requiredMsg: 'Påkrævet information mangler!',
        singlemonth_multiregional_composite_map: 'Sammensat rapport',
        statistical_for_tw_weeks: 'Data for de seneste 12 uger',
        weekly_case_count: 'Ugentlige sager',
        accu_mon_sel_simultaneously:
            '„Månedlige sager“ og „Akkumuleret lukningsrate“ kan ikke vælges samtidig!',
        mcc_mm_sr: 'Vælg flere måneder og ét område for „Månedlige sager“',
        acr_mm_sr: 'Vælg én måned og flere områder for „Akkumuleret lukningsrate“',
        distribution_Holding: 'Fordeling af beholdning',
        hour_response_rate: 'Svarprocent',
        Vehicle_fleet_size: 'Køretøjsflådestørrelse pr. model',
        num_of_cases: 'Antal sager',
        ratio: 'Andel',
        techl_inquiry_ratio: 'Andel tekniske henvendelser',
        close_logic: 'Lukningsstatistik',
        case_closure_rate: 'Sagernes lukningsrate',
        technical_closure_rate: 'Teknisk lukningsrate',
        doc_stats_scope: 'Dokumentstatistikomfang',
    },
    // 芬兰语
    fiFI: {
        area: 'Alue',
        monthly_case_count: 'Kuukausittaiset tapaukset',
        monthly_closed: 'Kuukausittain suljettu',
        monthly_closure_rate: 'Kuukausittainen sulkemisprosentti',
        accumulated_closure_rate: 'Kumulatiivinen sulkemisprosentti',
        case_count_closure_rate: 'Tapauksien määrä ja sulkemisprosentti',
        Key_market_technical_support_performance_statistics:
            'Tärkeimpien markkinoiden teknisen tuen suorituskyvyn tilastot',
        Accumulated_case_count: 'Kumulatiivinen tapausten määrä',
        Accumulated_closure_count: 'Kumulatiivinen suljettujen määrä',
        month_case_count: 'Kuukauden tapaukset',
        month_closure_count: 'Kuukauden suljetut tapaukset',
        five_Day_closure_rate: '5 päivän sulkemisprosentti',
        five_Day_closure_count: '5 päivässä suljettujen määrä',
        response_count_24hour: '24 tunnin sisällä vastattujen määrä',
        response_rate_24hour: '24 tunnin vastausprosentti',
        month_response_rate_24hour: '24 tunnin vastausprosentti',
        form_type: 'Lomakkeen tyyppi',
        repeat_multiple_choice_msg: 'Et voi valita useita kuukausia ja alueita samanaikaisesti!',
        day_closure_rate: 'Päivittäinen sulkemisprosentti',
        months_case_count: 'Kuukausittaiset tapaukset',
        individually: 'Yksittäin',
        full: 'Kaikki',
        received: 'Vastaanotettu',
        report: 'Raportoitu',
        regional_abbreviations: 'Alueiden lyhenteet',
        name_of_organisation: 'Organisaation nimi',
        form_of_documents: 'Asiakirjojen muoto',
        statistical_coverage: 'Tilastoalue',
        requiredMsg: 'Pakollisia tietoja puuttuu!',
        singlemonth_multiregional_composite_map: 'Yhdistelmäraportti',
        statistical_for_tw_weeks: 'Viimeisten 12 viikon tiedot',
        weekly_case_count: 'Viikoittaiset tapaukset',
        accu_mon_sel_simultaneously:
            '”Kuukausittaiset tapaukset” ja ”Kumulatiivinen sulkemisprosentti” eivät voi olla valittuna samaan aikaan!',
        mcc_mm_sr: 'Valitse useita kuukausia ja yksi alue kohdalle ”Kuukausittaiset tapaukset”',
        acr_mm_sr:
            'Valitse yksi kuukausi ja useita alueita kohdalle ”Kumulatiivinen sulkemisprosentti”',
        distribution_Holding: 'Varantojen jakauma',
        hour_response_rate: 'Vastausprosentti',
        Vehicle_fleet_size: 'Ajoneuvomalli kohtainen laivaston koko',
        num_of_cases: 'Tapauksien määrä',
        ratio: 'Suhde',
        techl_inquiry_ratio: 'Teknisten kyselyjen osuus',
        close_logic: 'Sulkemistilastot',
        case_closure_rate: 'Tapauksien sulkemisprosentti',
        technical_closure_rate: 'Tekninen sulkemisprosentti',
        doc_stats_scope: 'Asiakirjatilastojen kattavuus',
    },
    // 繁体中文台湾
    zhTW: {
        area: '區域',
        monthly_case_count: '月度案件數',
        monthly_closed: '月度已關閉',
        monthly_closure_rate: '月度關閉率',
        accumulated_closure_rate: '累計關閉率',
        case_count_closure_rate: '案例數與關閉率',
        Key_market_technical_support_performance_statistics: '重點市場技術支援表現統計',
        Accumulated_case_count: '累計案件數',
        Accumulated_closure_count: '累計關閉數',
        month_case_count: '月案件數',
        month_closure_count: '月關閉數',
        five_Day_closure_rate: '5天關閉率',
        five_Day_closure_count: '5天關閉數',
        response_count_24hour: '24小時答覆數',
        response_rate_24hour: '24小時回覆率',
        month_response_rate_24hour: '24小時回覆率',
        form_type: '表單類型',
        repeat_multiple_choice_msg: '月份與區域不可同時多選！',
        day_closure_rate: '天關閉率',
        months_case_count: '月度案件數',
        individually: '個體',
        full: '全部',
        received: '收到',
        report: '上報',
        regional_abbreviations: '區域簡稱',
        name_of_organisation: '組織名稱',
        form_of_documents: '單據形式',
        statistical_coverage: '統計範圍',
        requiredMsg: '必填資訊未填寫！',
        singlemonth_multiregional_composite_map: '整合報表',
        statistical_for_tw_weeks: '近12週數據',
        weekly_case_count: '週案件數',
        accu_mon_sel_simultaneously: '月度案件數 與 累計關閉率不能同時選擇！',
        mcc_mm_sr: '月度案件數請選擇多月單區域',
        acr_mm_sr: '累計關閉率請選擇單月多區域',
        distribution_Holding: '保有量分佈',
        hour_response_rate: '答覆率',
        Vehicle_fleet_size: '車型保有量',
        num_of_cases: '案例數',
        ratio: '比例',
        techl_inquiry_ratio: '技術問詢比例',
        close_logic: '關閉率統計',
        case_closure_rate: '案件關閉率',
        technical_closure_rate: '技術關閉率',
        doc_stats_scope: '單據統計範圍',
    },
    // 克罗地亚
    hrHR: {
        area: 'Područje',
        monthly_case_count: 'Broj slučajeva mjesečno',
        monthly_closed: 'Mjesečno zatvoreno',
        monthly_closure_rate: 'Mjesečna stopa zatvaranja',
        accumulated_closure_rate: 'Akumulirana stopa zatvaranja',
        case_count_closure_rate: 'Broj slučajeva i stopa zatvaranja',
        Key_market_technical_support_performance_statistics:
            'Statistika uspješnosti tehničke podrške na ključnim tržištima',
        Accumulated_case_count: 'Ukupan broj slučajeva',
        Accumulated_closure_count: 'Ukupan broj zatvorenih',
        month_case_count: 'Broj slučajeva u mjesecu',
        month_closure_count: 'Broj zatvorenih u mjesecu',
        five_Day_closure_rate: 'Stopa zatvaranja unutar 5 dana',
        five_Day_closure_count: 'Broj zatvorenih unutar 5 dana',
        response_count_24hour: 'Broj odgovora unutar 24 sata',
        response_rate_24hour: 'Postotak odgovora unutar 24 sata',
        month_response_rate_24hour: 'Postotak odgovora unutar 24 sata',
        form_type: 'Vrsta obrasca',
        repeat_multiple_choice_msg: 'Ne možete istovremeno odabrati više mjeseci i područja!',
        day_closure_rate: 'Dnevna stopa zatvaranja',
        months_case_count: 'Broj slučajeva mjesečno',
        individually: 'Pojedinačno',
        full: 'Sve',
        received: 'Primljeno',
        report: 'Prijavljeno',
        regional_abbreviations: 'Kratice područja',
        name_of_organisation: 'Naziv organizacije',
        form_of_documents: 'Oblik dokumenata',
        statistical_coverage: 'Statistički opseg',
        requiredMsg: 'Nedostaju obavezne informacije!',
        singlemonth_multiregional_composite_map: 'Kombinirano izvješće',
        statistical_for_tw_weeks: 'Podaci za posljednjih 12 tjedana',
        weekly_case_count: 'Tjedni broj slučajeva',
        accu_mon_sel_simultaneously:
            '"Broj slučajeva mjesečno" i "Akumulirana stopa zatvaranja" ne mogu se odabrati istovremeno!',
        mcc_mm_sr: 'Za "Broj slučajeva mjesečno" odaberite više mjeseci i jedno područje',
        acr_mm_sr: 'Za "Akumuliranu stopu zatvaranja" odaberite jedan mjesec i više područja',
        distribution_Holding: 'Distribucija zaliha',
        hour_response_rate: 'Postotak odgovora',
        Vehicle_fleet_size: 'Veličina voznog parka po modelu',
        num_of_cases: 'Broj slučajeva',
        ratio: 'Omjer',
        techl_inquiry_ratio: 'Omjer tehničkih upita',
        close_logic: 'Statistika stope zatvaranja',
        case_closure_rate: 'Stopa zatvaranja slučajeva',
        technical_closure_rate: 'Tehnička stopa zatvaranja',
        doc_stats_scope: 'Opseg statistike dokumenata',
    },
    // 拉脱维亚
    lvLV: {
        area: 'Reģions',
        monthly_case_count: 'Mēneša lietu skaits',
        monthly_closed: 'Mēneša slēgtās lietas',
        monthly_closure_rate: 'Mēneša slēgšanas līmenis',
        accumulated_closure_rate: 'Kopējais slēgšanas līmenis',
        case_count_closure_rate: 'Lietu skaits un slēgšanas līmenis',
        Key_market_technical_support_performance_statistics:
            'Galveno tirgu tehniskā atbalsta veiktspējas statistika',
        Accumulated_case_count: 'Kopējais lietu skaits',
        Accumulated_closure_count: 'Kopējais slēgto lietu skaits',
        month_case_count: 'Mēneša lietu skaits',
        month_closure_count: 'Mēneša slēgto lietu skaits',
        five_Day_closure_rate: '5 dienu slēgšanas līmenis',
        five_Day_closure_count: '5 dienu laikā slēgto lietu skaits',
        response_count_24hour: '24 stundu laikā sniegto atbilžu skaits',
        response_rate_24hour: '24 stundu atbildes līmenis',
        month_response_rate_24hour: '24 stundu atbildes līmenis',
        form_type: 'Veidlapas veids',
        repeat_multiple_choice_msg: 'Nevar vienlaicīgi izvēlēties vairākus mēnešus un reģionus!',
        day_closure_rate: 'Dienas slēgšanas līmenis',
        months_case_count: 'Mēneša lietu skaits',
        individually: 'Atsevišķi',
        full: 'Visi',
        received: 'Saņemts',
        report: 'Ziņots',
        regional_abbreviations: 'Reģionu saīsinājumi',
        name_of_organisation: 'Organizācijas nosaukums',
        form_of_documents: 'Dokumentu forma',
        statistical_coverage: 'Statistikas apgabals',
        requiredMsg: 'Trūkst obligātās informācijas!',
        singlemonth_multiregional_composite_map: 'Apvienotais pārskats',
        statistical_for_tw_weeks: 'Pēdējo 12 nedēļu dati',
        weekly_case_count: 'Nedēļas lietu skaits',
        accu_mon_sel_simultaneously:
            '"Mēneša lietu skaits" un "Kopējais slēgšanas līmenis" nevar būt izvēlēti vienlaicīgi!',
        mcc_mm_sr: '"Mēneša lietu skaitam" izvēlieties vairākus mēnešus un vienu reģionu',
        acr_mm_sr: '"Kopējam slēgšanas līmenim" izvēlieties vienu mēnesi un vairākus reģionus',
        distribution_Holding: 'Krājumu sadalījums',
        hour_response_rate: 'Atbildes līmenis',
        Vehicle_fleet_size: 'Transportlīdzekļu parka lielums pēc modeļa',
        num_of_cases: 'Lietu skaits',
        ratio: 'Attiecība',
        techl_inquiry_ratio: 'Tehnisko vaicājumu īpatsvars',
        close_logic: 'Slēgšanas statistika',
        case_closure_rate: 'Lietu slēgšanas līmenis',
        technical_closure_rate: 'Tehniskais slēgšanas līmenis',
        doc_stats_scope: 'Dokumentu statistikas apgabals',
    },
    // 立陶宛
    ltLT: {
        area: 'Regionas',
        monthly_case_count: 'Mėnesio bylų skaičius',
        monthly_closed: 'Uždaryta per mėnesį',
        monthly_closure_rate: 'Mėnesio uždarymo procentas',
        accumulated_closure_rate: 'Sukauptas uždarymo procentas',
        case_count_closure_rate: 'Bylų skaičius ir uždarymo procentas',
        Key_market_technical_support_performance_statistics:
            'Pagrindinių rinkų techninės pagalbos veiklos statistika',
        Accumulated_case_count: 'Sukauptas bylų skaičius',
        Accumulated_closure_count: 'Sukauptas uždarytų bylų skaičius',
        month_case_count: 'Mėnesio bylų skaičius',
        month_closure_count: 'Mėnesio uždarytų bylų skaičius',
        five_Day_closure_rate: '5 dienų uždarymo procentas',
        five_Day_closure_count: 'Uždaryta per 5 dienas',
        response_count_24hour: 'Atsakyta per 24 valandas',
        response_rate_24hour: '24 valandų atsakymo procentas',
        month_response_rate_24hour: '24 valandų atsakymo procentas',
        form_type: 'Formos tipas',
        repeat_multiple_choice_msg: 'Negalima vienu metu pasirinkti kelių mėnesių ir regionų!',
        day_closure_rate: 'Dienos uždarymo procentas',
        months_case_count: 'Mėnesio bylų skaičius',
        individually: 'Individualiai',
        full: 'Visi',
        received: 'Gauta',
        report: 'Pranešta',
        regional_abbreviations: 'Regionų santrumpos',
        name_of_organisation: 'Organizacijos pavadinimas',
        form_of_documents: 'Dokumentų forma',
        statistical_coverage: 'Statistikos apimtis',
        requiredMsg: 'Trūksta privalomos informacijos!',
        singlemonth_multiregional_composite_map: 'Integruota ataskaita',
        statistical_for_tw_weeks: 'Paskutinių 12 savaičių duomenys',
        weekly_case_count: 'Savaitės bylų skaičius',
        accu_mon_sel_simultaneously:
            '"Mėnesio bylų skaičius" ir "Sukauptas uždarymo procentas" negali būti pasirinkti kartu!',
        mcc_mm_sr: '"Mėnesio bylų skaičiui" pasirinkite kelis mėnesius ir vieną regioną',
        acr_mm_sr: '"Sukauptam uždarymo procentui" pasirinkite vieną mėnesį ir kelis regionus',
        distribution_Holding: 'Turimos apimties pasiskirstymas',
        hour_response_rate: 'Atsakymo procentas',
        Vehicle_fleet_size: 'Transporto priemonių parko dydis pagal modelį',
        num_of_cases: 'Bylų skaičius',
        ratio: 'Santykis',
        techl_inquiry_ratio: 'Techninių užklausų dalis',
        close_logic: 'Uždarymo statistika',
        case_closure_rate: 'Bylų uždarymo procentas',
        technical_closure_rate: 'Techninis uždarymo procentas',
        doc_stats_scope: 'Dokumentų statistikos apimtis',
    },
    // 罗马尼亚
    roRO: {
        area: 'Zonă',
        monthly_case_count: 'Număr de cazuri lunare',
        monthly_closed: 'Închise lunar',
        monthly_closure_rate: 'Rată lunară de închidere',
        accumulated_closure_rate: 'Rată cumulată de închidere',
        case_count_closure_rate: 'Număr de cazuri și rată de închidere',
        Key_market_technical_support_performance_statistics:
            'Statistici privind performanța asistenței tehnice pe piețele cheie',
        Accumulated_case_count: 'Număr total de cazuri',
        Accumulated_closure_count: 'Număr total închise',
        month_case_count: 'Număr de cazuri în lună',
        month_closure_count: 'Număr închise în lună',
        five_Day_closure_rate: 'Rată de închidere în 5 zile',
        five_Day_closure_count: 'Număr închise în 5 zile',
        response_count_24hour: 'Număr de răspunsuri în 24h',
        response_rate_24hour: 'Rată de răspuns în 24h',
        month_response_rate_24hour: 'Rată de răspuns în 24h',
        form_type: 'Tip formular',
        repeat_multiple_choice_msg: 'Nu puteți selecta simultan mai multe luni și zone!',
        day_closure_rate: 'Rată zilnică de închidere',
        months_case_count: 'Număr de cazuri lunare',
        individually: 'Individual',
        full: 'Toate',
        received: 'Primit',
        report: 'Raportat',
        regional_abbreviations: 'Abrevieri zonale',
        name_of_organisation: 'Numele organizației',
        form_of_documents: 'Forma documentelor',
        statistical_coverage: 'Domeniu statistic',
        requiredMsg: 'Informații obligatorii lipsă!',
        singlemonth_multiregional_composite_map: 'Raport combinat',
        statistical_for_tw_weeks: 'Date din ultimele 12 săptămâni',
        weekly_case_count: 'Număr săptămânal de cazuri',
        accu_mon_sel_simultaneously:
            '„Număr de cazuri lunare” și „Rată cumulată de închidere” nu pot fi selectate simultan!',
        mcc_mm_sr: 'Pentru „Număr de cazuri lunare”, selectați mai multe luni și o singură zonă',
        acr_mm_sr:
            'Pentru „Rată cumulată de închidere”, selectați o singură lună și mai multe zone',
        distribution_Holding: 'Distribuția stocului',
        hour_response_rate: 'Rată de răspuns',
        Vehicle_fleet_size: 'Dimensiunea parcului auto pe model',
        num_of_cases: 'Număr de cazuri',
        ratio: 'Raport',
        techl_inquiry_ratio: 'Proporția întrebărilor tehnice',
        close_logic: 'Statistica ratei de închidere',
        case_closure_rate: 'Rata de închidere a cazurilor',
        technical_closure_rate: 'Rata tehnică de închidere',
        doc_stats_scope: 'Domeniul statistic al documentelor',
    },
    // 挪威博克马尔
    nbNO: {
        area: 'Område',
        monthly_case_count: 'Månedlig saksmengde',
        monthly_closed: 'Månedlig lukket',
        monthly_closure_rate: 'Månedlig lukkerate',
        accumulated_closure_rate: 'Akkumulert lukkerate',
        case_count_closure_rate: 'Antall saker og lukkerate',
        Key_market_technical_support_performance_statistics:
            'Statistikk for teknisk støtteytelse i nøkkelmarkeder',
        Accumulated_case_count: 'Akkumulert antall saker',
        Accumulated_closure_count: 'Akkumulert antall lukket',
        month_case_count: 'Saker denne måneden',
        month_closure_count: 'Lukket denne måneden',
        five_Day_closure_rate: '5-dagers lukkerate',
        five_Day_closure_count: 'Antall lukket innen 5 dager',
        response_count_24hour: 'Antall svar innen 24 timer',
        response_rate_24hour: 'Svarprosent innen 24 timer',
        month_response_rate_24hour: 'Svarprosent innen 24 timer',
        form_type: 'Skjematype',
        repeat_multiple_choice_msg: 'Du kan ikke velge flere måneder og områder samtidig!',
        day_closure_rate: 'Dagslukkerate',
        months_case_count: 'Månedlig saksmengde',
        individually: 'Individuelt',
        full: 'Alle',
        received: 'Mottatt',
        report: 'Rapportert',
        regional_abbreviations: 'Områdeforkortelser',
        name_of_organisation: 'Organisasjonsnavn',
        form_of_documents: 'Dokumentform',
        statistical_coverage: 'Statistikkomfang',
        requiredMsg: 'Påkrevd informasjon mangler!',
        singlemonth_multiregional_composite_map: 'Sammensatt rapport',
        statistical_for_tw_weeks: 'Data for de siste 12 ukene',
        weekly_case_count: 'Ukentlig saksmengde',
        accu_mon_sel_simultaneously:
            '„Månedlig saksmengde“ og „Akkumulert lukkerate“ kan ikke velges samtidig!',
        mcc_mm_sr: 'Velg flere måneder og ett område for „Månedlig saksmengde“',
        acr_mm_sr: 'Velg én måned og flere områder for „Akkumulert lukkerate“',
        distribution_Holding: 'Fordeling av beholdning',
        hour_response_rate: 'Svarprosent',
        Vehicle_fleet_size: 'Bilparkstørrelse per modell',
        num_of_cases: 'Antall saker',
        ratio: 'Andel',
        techl_inquiry_ratio: 'Andel tekniske forespørsler',
        close_logic: 'Lukkestatisikk',
        case_closure_rate: 'Sakslukkerate',
        technical_closure_rate: 'Teknisk lukkerate',
        doc_stats_scope: 'Dokumentstatistikkomfang',
    },
    // 葡萄牙语巴西
    ptBX: {
        area: 'Região',
        monthly_case_count: 'Número de casos mensais',
        monthly_closed: 'Fechados no mês',
        monthly_closure_rate: 'Taxa de fechamento mensal',
        accumulated_closure_rate: 'Taxa de fechamento acumulada',
        case_count_closure_rate: 'Número de casos e taxa de fechamento',
        Key_market_technical_support_performance_statistics:
            'Estatísticas de desempenho do suporte técnico em mercados-chave',
        Accumulated_case_count: 'Número total de casos',
        Accumulated_closure_count: 'Total de fechados',
        month_case_count: 'Casos no mês',
        month_closure_count: 'Fechados no mês',
        five_Day_closure_rate: 'Taxa de fechamento em 5 dias',
        five_Day_closure_count: 'Fechados em 5 dias',
        response_count_24hour: 'Respostas em 24h',
        response_rate_24hour: 'Taxa de resposta em 24h',
        month_response_rate_24hour: 'Taxa de resposta em 24h',
        form_type: 'Tipo de formulário',
        repeat_multiple_choice_msg:
            'Não é possível selecionar múltiplos meses e regiões ao mesmo tempo!',
        day_closure_rate: 'Taxa de fechamento diária',
        months_case_count: 'Número de casos mensais',
        individually: 'Individual',
        full: 'Todos',
        received: 'Recebido',
        report: 'Relatado',
        regional_abbreviations: 'Abreviações regionais',
        name_of_organisation: 'Nome da organização',
        form_of_documents: 'Formato dos documentos',
        statistical_coverage: 'Abrangência estatística',
        requiredMsg: 'Informações obrigatórias não preenchidas!',
        singlemonth_multiregional_composite_map: 'Relatório consolidado',
        statistical_for_tw_weeks: 'Dados das últimas 12 semanas',
        weekly_case_count: 'Casos semanais',
        accu_mon_sel_simultaneously:
            '“Número de casos mensais” e “Taxa de fechamento acumulada” não podem ser selecionados simultaneamente!',
        mcc_mm_sr: 'Para “Número de casos mensais”, selecione vários meses e uma única região',
        acr_mm_sr: 'Para “Taxa de fechamento acumulada”, selecione um único mês e várias regiões',
        distribution_Holding: 'Distribuição de frota',
        hour_response_rate: 'Taxa de resposta',
        Vehicle_fleet_size: 'Tamanho da frota por modelo',
        num_of_cases: 'Número de casos',
        ratio: 'Proporção',
        techl_inquiry_ratio: 'Proporção de consultas técnicas',
        close_logic: 'Estatística de fechamento',
        case_closure_rate: 'Taxa de fechamento de casos',
        technical_closure_rate: 'Taxa técnica de fechamento',
        doc_stats_scope: 'Escopo estatístico dos documentos',
    },
    // 瑞典语
    svSE: {
        area: 'Område',
        monthly_case_count: 'Antal ärenden per månad',
        monthly_closed: 'Stängda under månaden',
        monthly_closure_rate: 'Månadsvis stängningsfrekvens',
        accumulated_closure_rate: 'Ackumulerad stängningsfrekvens',
        case_count_closure_rate: 'Antal ärenden och stängningsfrekvens',
        Key_market_technical_support_performance_statistics:
            'Statistik över teknisk supportprestation i nyckelmarknader',
        Accumulated_case_count: 'Ackumulerat antal ärenden',
        Accumulated_closure_count: 'Ackumulerat antal stängda',
        month_case_count: 'Ärenden denna månad',
        month_closure_count: 'Stängda denna månad',
        five_Day_closure_rate: '5-dagars stängningsfrekvens',
        five_Day_closure_count: 'Antal stängda inom 5 dagar',
        response_count_24hour: 'Antal svar inom 24 timmar',
        response_rate_24hour: 'Svarsfrekvens inom 24 timmar',
        month_response_rate_24hour: 'Svarsfrekvens inom 24 timmar',
        form_type: 'Formulärtyp',
        repeat_multiple_choice_msg: 'Du kan inte välja flera månader och områden samtidigt!',
        day_closure_rate: 'Dagsvis stängningsfrekvens',
        months_case_count: 'Antal ärenden per månad',
        individually: 'Individuellt',
        full: 'Alla',
        received: 'Mottaget',
        report: 'Rapporterat',
        regional_abbreviations: 'Områdesförkortningar',
        name_of_organisation: 'Organisationsnamn',
        form_of_documents: 'Dokumentformat',
        statistical_coverage: 'Statistikomfattning',
        requiredMsg: 'Obligatorisk information saknas!',
        singlemonth_multiregional_composite_map: 'Sammanställd rapport',
        statistical_for_tw_weeks: 'Data för de senaste 12 veckorna',
        weekly_case_count: 'Veckovisa ärenden',
        accu_mon_sel_simultaneously:
            '“Antal ärenden per månad” och “Ackumulerad stängningsfrekvens” kan inte väljas samtidigt!',
        mcc_mm_sr: 'Välj flera månader och ett område för “Antal ärenden per månad”',
        acr_mm_sr: 'Välj en månad och flera områden för “Ackumulerad stängningsfrekvens”',
        distribution_Holding: 'Distribution av fordonspark',
        hour_response_rate: 'Svarsfrekvens',
        Vehicle_fleet_size: 'Fordonsflottans storlek per modell',
        num_of_cases: 'Antal ärenden',
        ratio: 'Andel',
        techl_inquiry_ratio: 'Andel tekniska förfrågningar',
        close_logic: 'Stängningsstatistik',
        case_closure_rate: 'Ärendenas stängningsfrekvens',
        technical_closure_rate: 'Teknisk stängningsfrekvens',
        doc_stats_scope: 'Dokumentstatistikens omfattning',
    },
    // 斯洛伐克
    skSK: {
        area: 'Oblasť',
        monthly_case_count: 'Počet prípadov mesačne',
        monthly_closed: 'Mesačne uzatvorené',
        monthly_closure_rate: 'Mesačná miera uzatvorenia',
        accumulated_closure_rate: 'Kumulatívna miera uzatvorenia',
        case_count_closure_rate: 'Počet prípadov a miera uzatvorenia',
        Key_market_technical_support_performance_statistics:
            'Štatistika výkonu technickej podpory na kľúčových trhoch',
        Accumulated_case_count: 'Kumulatívny počet prípadov',
        Accumulated_closure_count: 'Kumulatívny počet uzatvorených',
        month_case_count: 'Počet prípadov v mesiaci',
        month_closure_count: 'Počet uzatvorených v mesiaci',
        five_Day_closure_rate: 'Miera uzatvorenia do 5 dní',
        five_Day_closure_count: 'Počet uzatvorených do 5 dní',
        response_count_24hour: 'Počet odpovedí do 24 hodín',
        response_rate_24hour: 'Miera odpovedí do 24 hodín',
        month_response_rate_24hour: 'Miera odpovedí do 24 hodín',
        form_type: 'Typ formulára',
        repeat_multiple_choice_msg: 'Nie je možné súčasne vybrať viacero mesiacov a oblastí!',
        day_closure_rate: 'Denná miera uzatvorenia',
        months_case_count: 'Počet prípadov mesačne',
        individually: 'Jednotlivo',
        full: 'Všetky',
        received: 'Prijaté',
        report: 'Nahlásené',
        regional_abbreviations: 'Skratky oblastí',
        name_of_organisation: 'Názov organizácie',
        form_of_documents: 'Forma dokumentov',
        statistical_coverage: 'Štatistický rozsah',
        requiredMsg: 'Chýbajú povinné údaje!',
        singlemonth_multiregional_composite_map: 'Zhrnutý prehľad',
        statistical_for_tw_weeks: 'Údaje za posledných 12 týždňov',
        weekly_case_count: 'Týždenný počet prípadov',
        accu_mon_sel_simultaneously:
            '„Počet prípadov mesačne“ a „Kumulatívna miera uzatvorenia“ sa nemôžu vybrať súčasne!',
        mcc_mm_sr: 'Pre „Počet prípadov mesačne“ vyberte viacero mesiacov a jednu oblasť',
        acr_mm_sr: 'Pre „Kumulatívnu mieru uzatvorenia“ vyberte jeden mesiac a viacero oblastí',
        distribution_Holding: 'Rozloženie zásob',
        hour_response_rate: 'Miera odpovedí',
        Vehicle_fleet_size: 'Veľkosť vozového parku podľa modelu',
        num_of_cases: 'Počet prípadov',
        ratio: 'Pomer',
        techl_inquiry_ratio: 'Pomer technických dopytov',
        close_logic: 'Štatistika miery uzatvorenia',
        case_closure_rate: 'Miera uzatvorenia prípadov',
        technical_closure_rate: 'Technická miera uzatvorenia',
        doc_stats_scope: 'Rozsah štatistiky dokumentov',
    },
    // 斯洛文尼亚
    slSI: {
        area: 'Območje',
        monthly_case_count: 'Število primerov na mesec',
        monthly_closed: 'Mesečno zaprtih',
        monthly_closure_rate: 'Mesečna stopnja zaprtja',
        accumulated_closure_rate: 'Skupna stopnja zaprtja',
        case_count_closure_rate: 'Število primerov in stopnja zaprtja',
        Key_market_technical_support_performance_statistics:
            'Statistika uspešnosti tehnične podpore na ključnih trgih',
        Accumulated_case_count: 'Skupno število primerov',
        Accumulated_closure_count: 'Skupno število zaprtih',
        month_case_count: 'Število primerov v mesecu',
        month_closure_count: 'Število zaprtih v mesecu',
        five_Day_closure_rate: 'Stopnja zaprtja v 5 dneh',
        five_Day_closure_count: 'Število zaprtih v 5 dneh',
        response_count_24hour: 'Število odgovorov v 24 urah',
        response_rate_24hour: 'Odstotek odgovorov v 24 urah',
        month_response_rate_24hour: 'Odstotek odgovorov v 24 urah',
        form_type: 'Vrsta obrazca',
        repeat_multiple_choice_msg: 'Ne morete hkrati izbrati več mesecev in območij!',
        day_closure_rate: 'Dnevna stopnja zaprtja',
        months_case_count: 'Število primerov na mesec',
        individually: 'Posamično',
        full: 'Vsi',
        received: 'Prejeto',
        report: 'Poročano',
        regional_abbreviations: 'Okrajšave območij',
        name_of_organisation: 'Ime organizacije',
        form_of_documents: 'Oblika dokumentov',
        statistical_coverage: 'Statistični obseg',
        requiredMsg: 'Manjkajo obvezni podatki!',
        singlemonth_multiregional_composite_map: 'Združeno poročilo',
        statistical_for_tw_weeks: 'Podatki zadnjih 12 tednov',
        weekly_case_count: 'Tedensko število primerov',
        accu_mon_sel_simultaneously:
            '„Število primerov na mesec“ in „Skupna stopnja zaprtja“ ne moreta biti izbrana hkrati!',
        mcc_mm_sr: 'Za „Število primerov na mesec“ izberite več mesecev in eno območje',
        acr_mm_sr: 'Za „Skupno stopnjo zaprtja“ izberite en mesec in več območij',
        distribution_Holding: 'Porazdelitev zalog',
        hour_response_rate: 'Odstotek odgovorov',
        Vehicle_fleet_size: 'Velikost vozilnega parka po modelu',
        num_of_cases: 'Število primerov',
        ratio: 'Razmerje',
        techl_inquiry_ratio: 'Delež tehničnih poizvedb',
        close_logic: 'Statistika stopnje zaprtja',
        case_closure_rate: 'Stopnja zaprtja primerov',
        technical_closure_rate: 'Tehnična stopnja zaprtja',
        doc_stats_scope: 'Obseg statistike dokumentov',
    },
    // 泰语
    thTH: {
        area: 'พื้นที่',
        monthly_case_count: 'จำนวนเคสต่อเดือน',
        monthly_closed: 'ปิดแล้วรายเดือน',
        monthly_closure_rate: 'อัตราการปิดรายเดือน',
        accumulated_closure_rate: 'อัตราการปิดสะสม',
        case_count_closure_rate: 'จำนวนเคสและอัตราการปิด',
        Key_market_technical_support_performance_statistics:
            'สถิติประสิทธิภาพการสนับสนุนทางเทคนิคในตลาดหลัก',
        Accumulated_case_count: 'จำนวนเคสรวมสะสม',
        Accumulated_closure_count: 'จำนวนเคสที่ปิดรวมสะสม',
        month_case_count: 'จำนวนเคสในเดือนนี้',
        month_closure_count: 'จำนวนเคสที่ปิดในเดือนนี้',
        five_Day_closure_rate: 'อัตราการปิดภายใน 5 วัน',
        five_Day_closure_count: 'จำนวนเคสที่ปิดภายใน 5 วัน',
        response_count_24hour: 'จำนวนการตอบกลับภายใน 24 ชม.',
        response_rate_24hour: 'อัตราการตอบกลับภายใน 24 ชม.',
        month_response_rate_24hour: 'อัตราการตอบกลับภายใน 24 ชม.',
        form_type: 'ประเภทแบบฟอร์ม',
        repeat_multiple_choice_msg: 'ไม่สามารถเลือกหลายเดือนและหลายพื้นที่พร้อมกันได้!',
        day_closure_rate: 'อัตราการปิดรายวัน',
        months_case_count: 'จำนวนเคสต่อเดือน',
        individually: 'รายบุคคล',
        full: 'ทั้งหมด',
        received: 'ได้รับแล้ว',
        report: 'รายงานแล้ว',
        regional_abbreviations: 'ชื่อย่อภูมิภาค',
        name_of_organisation: 'ชื่อองค์กร',
        form_of_documents: 'รูปแบบเอกสาร',
        statistical_coverage: 'ขอบเขตสถิติ',
        requiredMsg: 'ยังไม่ได้กรอกข้อมูลที่จำเป็น!',
        singlemonth_multiregional_composite_map: 'รายงานรวม',
        statistical_for_tw_weeks: 'ข้อมูล 12 สัปดาห์ล่าสุด',
        weekly_case_count: 'จำนวนเคสรายสัปดาห์',
        accu_mon_sel_simultaneously:
            'ไม่สามารถเลือก "จำนวนเคสต่อเดือน" และ "อัตราการปิดสะสม" พร้อมกันได้!',
        mcc_mm_sr: 'สำหรับ "จำนวนเคสต่อเดือน" กรุณาเลือกหลายเดือนและพื้นที่เดียว',
        acr_mm_sr: 'สำหรับ "อัตราการปิดสะสม" กรุณาเลือกเดือนเดียวและหลายพื้นที่',
        distribution_Holding: 'การกระจายปริมาณคงคลัง',
        hour_response_rate: 'อัตราการตอบกลับ',
        Vehicle_fleet_size: 'จำนวนรถตามรุ่น',
        num_of_cases: 'จำนวนเคส',
        ratio: 'สัดส่วน',
        techl_inquiry_ratio: 'สัดส่วนการสอบถามด้านเทคนิค',
        close_logic: 'สถิติอัตราการปิด',
        case_closure_rate: 'อัตราการปิดเคส',
        technical_closure_rate: 'อัตราการปิดเชิงเทคนิค',
        doc_stats_scope: 'ขอบเขตสถิติเอกสาร',
    },
    // 乌克兰语
    ukUA: {
        area: 'Регіон',
        monthly_case_count: 'Кількість справ на місяць',
        monthly_closed: 'Закрито за місяць',
        monthly_closure_rate: 'Місячний відсоток закриття',
        accumulated_closure_rate: 'Накопичений відсоток закриття',
        case_count_closure_rate: 'Кількість справ та відсоток закриття',
        Key_market_technical_support_performance_statistics:
            'Статистика ефективності технічної підтримки на ключових ринках',
        Accumulated_case_count: 'Загальна кількість справ',
        Accumulated_closure_count: 'Загальна кількість закритих',
        month_case_count: 'Кількість справ у місяці',
        month_closure_count: 'Кількість закритих у місяці',
        five_Day_closure_rate: 'Відсоток закриття за 5 днів',
        five_Day_closure_count: 'Кількість закритих за 5 днів',
        response_count_24hour: 'Кількість відповідей протягом 24 годин',
        response_rate_24hour: 'Відсоток відповідей протягом 24 годин',
        month_response_rate_24hour: 'Відсоток відповідей протягом 24 годин',
        form_type: 'Тип форми',
        repeat_multiple_choice_msg: 'Неможливо одночасно обрати кілька місяців і регіонів!',
        day_closure_rate: 'Щоденний відсоток закриття',
        months_case_count: 'Кількість справ на місяць',
        individually: 'Окремо',
        full: 'Усі',
        received: 'Отримано',
        report: 'Повідомлено',
        regional_abbreviations: 'Абревіатури регіонів',
        name_of_organisation: 'Назва організації',
        form_of_documents: 'Форма документів',
        statistical_coverage: 'Статистичний охоп',
        requiredMsg: 'Не заповнено обов’язкову інформацію!',
        singlemonth_multiregional_composite_map: 'Зведений звіт',
        statistical_for_tw_weeks: 'Дані за останні 12 тижнів',
        weekly_case_count: 'Кількість справ на тиждень',
        accu_mon_sel_simultaneously:
            'Неможливо одночасно обрати "Кількість справ на місяць" та "Накопичений відсоток закриття"!',
        mcc_mm_sr: 'Для "Кількості справ на місяць" оберіть кілька місяців і один регіон',
        acr_mm_sr: 'Для "Накопиченого відсотка закриття" оберіть один місяць і кілька регіонів',
        distribution_Holding: 'Розподіл наявних обсягів',
        hour_response_rate: 'Відсоток відповідей',
        Vehicle_fleet_size: 'Розмір автопарку за моделлю',
        num_of_cases: 'Кількість справ',
        ratio: 'Співвідношення',
        techl_inquiry_ratio: 'Частка технічних запитів',
        close_logic: 'Статистика відсотка закриття',
        case_closure_rate: 'Відсоток закриття справ',
        technical_closure_rate: 'Технічний відсоток закриття',
        doc_stats_scope: 'Область статистики документів',
    },
    // 希腊语
    elGR: {
        area: 'Περιοχή',
        monthly_case_count: 'Μηνιαίος αριθμός περιστατικών',
        monthly_closed: 'Μηνιαία κλεισμένα',
        monthly_closure_rate: 'Μηνιαίο ποσοστό κλεισίματος',
        accumulated_closure_rate: 'Συγκεντρωτικό ποσοστό κλεισίματος',
        case_count_closure_rate: 'Αριθμός περιστατικών και ποσοστό κλεισίματος',
        Key_market_technical_support_performance_statistics:
            'Στατιστικά απόδοσης τεχνικής υποστήριξης σε κύριες αγορές',
        Accumulated_case_count: 'Συγκεντρωτικός αριθμός περιστατικών',
        Accumulated_closure_count: 'Συγκεντρωτικός αριθμός κλεισμένων',
        month_case_count: 'Περιστατικά μήνα',
        month_closure_count: 'Κλεισμένα μήνα',
        five_Day_closure_rate: 'Ποσοστό κλεισίματος εντός 5 ημερών',
        five_Day_closure_count: 'Αριθμός κλεισμένων εντός 5 ημερών',
        response_count_24hour: 'Αριθμός απαντήσεων εντός 24 ωρών',
        response_rate_24hour: 'Ποσοστό απάντησης εντός 24 ωρών',
        month_response_rate_24hour: 'Ποσοστό απάντησης εντός 24 ωρών',
        form_type: 'Τύπος φόρμας',
        repeat_multiple_choice_msg:
            'Δεν μπορείτε να επιλέξετε ταυτόχρονα πολλούς μήνες και περιοχές!',
        day_closure_rate: 'Ημερήσιο ποσοστό κλεισίματος',
        months_case_count: 'Μηνιαίος αριθμός περιστατικών',
        individually: 'Ατομικά',
        full: 'Όλα',
        received: 'Ληφθέντα',
        report: 'Αναφέρθηκαν',
        regional_abbreviations: 'Συντομογραφίες περιοχών',
        name_of_organisation: 'Όνομα οργανισμού',
        form_of_documents: 'Μορφή εγγράφων',
        statistical_coverage: 'Στατιστική κάλυψη',
        requiredMsg: 'Λείπουν υποχρεωτικά στοιχεία!',
        singlemonth_multiregional_composite_map: 'Συγκεντρωτική αναφορά',
        statistical_for_tw_weeks: 'Δεδομένα τελευταίων 12 εβδομάδων',
        weekly_case_count: 'Εβδομαδιαίος αριθμός περιστατικών',
        accu_mon_sel_simultaneously:
            'Δεν μπορείτε να επιλέξετε ταυτόχρονα "Μηνιαίος αριθμός περιστατικών" και "Συγκεντρωτικό ποσοστό κλεισίματος"!',
        mcc_mm_sr: 'Για το "Μηνιαίο αριθμό περιστατικών", επιλέξτε πολλούς μήνες και μία περιοχή',
        acr_mm_sr:
            'Για το "Συγκεντρωτικό ποσοστό κλεισίματος", επιλέξτε έναν μήνα και πολλές περιοχές',
        distribution_Holding: 'Κατανομή διαθεσιμότητας',
        hour_response_rate: 'Ποσοστό απάντησης',
        Vehicle_fleet_size: 'Μέγεθος στόλου ανά μοντέλο',
        num_of_cases: 'Αριθμός περιστατικών',
        ratio: 'Αναλογία',
        techl_inquiry_ratio: 'Αναλογία τεχνικών ερωτημάτων',
        close_logic: 'Στατιστικά κλεισίματος',
        case_closure_rate: 'Ποσοστό κλεισίματος περιστατικών',
        technical_closure_rate: 'Τεχνικό ποσοστό κλεισίματος',
        doc_stats_scope: 'Εύρος στατιστικών εγγράφων',
    },
    // 爱沙尼亚
    etEE: {
        area: 'Piirkond',
        monthly_case_count: 'Juhtumite arv kuus',
        monthly_closed: 'Kuus suletud',
        monthly_closure_rate: 'Kuine sulgemismäär',
        accumulated_closure_rate: 'Kumulatiivne sulgemismäär',
        case_count_closure_rate: 'Juhtumite arv ja sulgemismäär',
        Key_market_technical_support_performance_statistics:
            'Peamiste turgude tehnilise toe jõudluse statistika',
        Accumulated_case_count: 'Kumulatiivne juhtumite arv',
        Accumulated_closure_count: 'Kumulatiivne suletud juhtumite arv',
        month_case_count: 'Kuu juhtumite arv',
        month_closure_count: 'Kuu suletud juhtumite arv',
        five_Day_closure_rate: '5-päevane sulgemismäär',
        five_Day_closure_count: '5 päeva jooksul suletud juhtumite arv',
        response_count_24hour: '24 tunni jooksul vastatud juhtumite arv',
        response_rate_24hour: '24-tunnine vastusemäär',
        month_response_rate_24hour: '24-tunnine vastusemäär',
        form_type: 'Vormi tüüp',
        repeat_multiple_choice_msg: 'Mitmeid kuusid ja piirkondi ei saa korraga valida!',
        day_closure_rate: 'Päevane sulgemismäär',
        months_case_count: 'Juhtumite arv kuus',
        individually: 'Üksikult',
        full: 'Kõik',
        received: 'Vastu võetud',
        report: 'Teatatud',
        regional_abbreviations: 'Piirkondade lühendid',
        name_of_organisation: 'Organisatsiooni nimi',
        form_of_documents: 'Dokumentide vorm',
        statistical_coverage: 'Statistika ulatus',
        requiredMsg: 'Kohustuslikku teavet pole täidetud!',
        singlemonth_multiregional_composite_map: 'Koondaruande',
        statistical_for_tw_weeks: 'Viimase 12 nädala andmed',
        weekly_case_count: 'Nädalane juhtumite arv',
        accu_mon_sel_simultaneously:
            '"Juhtumite arv kuus" ja "Kumulatiivne sulgemismäär" ei saa olla korraga valitud!',
        mcc_mm_sr: '"Juhtumite arvu kuus" jaoks valige mitu kuud ja üks piirkond',
        acr_mm_sr: '"Kumulatiivse sulgemismäära" jaoks valige üks kuu ja mitu piirkonda',
        distribution_Holding: 'Laoseisu jaotus',
        hour_response_rate: 'Vastusemäär',
        Vehicle_fleet_size: 'Sõidukipargi suurus mudeli kaupa',
        num_of_cases: 'Juhtumite arv',
        ratio: 'Suhe',
        techl_inquiry_ratio: 'Tehniliste päringute osakaal',
        close_logic: 'Sulgemise statistika',
        case_closure_rate: 'Juhtumite sulgemismäär',
        technical_closure_rate: 'Tehniline sulgemismäär',
        doc_stats_scope: 'Dokumentide statistika ulatus',
    },
    // 哈萨克
    kkKZ: {
        area: 'Аймақ',
        monthly_case_count: 'Айлық істер саны',
        monthly_closed: 'Ай сайын жабылған',
        monthly_closure_rate: 'Айлық жабу пайызы',
        accumulated_closure_rate: 'Жинақталған жабу пайызы',
        case_count_closure_rate: 'Істер саны мен жабу пайызы',
        Key_market_technical_support_performance_statistics:
            'Негізгі нарықтардағы техникалық қолдау көрсету нәтижелерінің статистикасы',
        Accumulated_case_count: 'Жинақталған істер саны',
        Accumulated_closure_count: 'Жинақталған жабылған істер саны',
        month_case_count: 'Айлық істер саны',
        month_closure_count: 'Айлық жабылған істер саны',
        five_Day_closure_rate: '5 күндік жабу пайызы',
        five_Day_closure_count: '5 күн ішінде жабылған істер саны',
        response_count_24hour: '24 сағат ішіндегі жауап берілген істер саны',
        response_rate_24hour: '24 сағат ішіндегі жауап беру пайызы',
        month_response_rate_24hour: '24 сағат ішіндегі жауап беру пайызы',
        form_type: 'Форма түрі',
        repeat_multiple_choice_msg: 'Бірнеше ай мен аймақты бір уақытта таңдауға болмайды!',
        day_closure_rate: 'Күндік жабу пайызы',
        months_case_count: 'Айлық істер саны',
        individually: 'Жеке',
        full: 'Барлығы',
        received: 'Алынды',
        report: 'Есеп берілді',
        regional_abbreviations: 'Аймақтардың қысқартылған атаулары',
        name_of_organisation: 'Ұйым атауы',
        form_of_documents: 'Құжаттар түрі',
        statistical_coverage: 'Статистикалық ауқым',
        requiredMsg: 'Міндетті ақпарат толтырылмаған!',
        singlemonth_multiregional_composite_map: 'Біріктірілген есеп',
        statistical_for_tw_weeks: 'Соңғы 12 аптаның деректері',
        weekly_case_count: 'Апта сайынғы істер саны',
        accu_mon_sel_simultaneously:
            '"Айлық істер саны" мен "Жинақталған жабу пайызы" бір уақытта таңдалмайды!',
        mcc_mm_sr: '"Айлық істер саны" үшін бірнеше ай мен бір аймақты таңдаңыз',
        acr_mm_sr: '"Жинақталған жабу пайызы" үшін бір ай мен бірнеше аймақты таңдаңыз',
        distribution_Holding: 'Автомобильдер санының таралуы',
        hour_response_rate: 'Жауап беру пайызы',
        Vehicle_fleet_size: 'Модель бойынша автомобильдер саны',
        num_of_cases: 'Істер саны',
        ratio: 'Үлес',
        techl_inquiry_ratio: 'Техникалық сұраулар үлесі',
        close_logic: 'Жабу статистикасы',
        case_closure_rate: 'Істерді жабу пайызы',
        technical_closure_rate: 'Техникалық жабу пайызы',
        doc_stats_scope: 'Құжаттар статистикасының ауқымы',
    },
    // 希伯来语
    heIL: {
        area: 'אזור',
        monthly_case_count: 'מספר מקרים חודשי',
        monthly_closed: 'סגורים לחודש',
        monthly_closure_rate: 'אחוז סגירה חודשי',
        accumulated_closure_rate: 'אחוז סגירה מצטבר',
        case_count_closure_rate: 'מספר מקרים ואחוז סגירה',
        Key_market_technical_support_performance_statistics:
            'סטטיסטיקות ביצועי תמיכה טכנית בשווקים מרכזיים',
        Accumulated_case_count: 'סה״כ מקרים מצטברים',
        Accumulated_closure_count: 'סה״כ סגורים מצטברים',
        month_case_count: 'מקרים בחודש',
        month_closure_count: 'סגורים בחודש',
        five_Day_closure_rate: 'אחוז סגירה תוך 5 ימים',
        five_Day_closure_count: 'מספר סגורים תוך 5 ימים',
        response_count_24hour: 'מספר תגובות תוך 24 שעות',
        response_rate_24hour: 'אחוז תגובות תוך 24 שעות',
        month_response_rate_24hour: 'אחוז תגובות תוך 24 שעות',
        form_type: 'סוג טופס',
        repeat_multiple_choice_msg: 'לא ניתן לבחור בו זמנית מספר חודשים ואזורים!',
        day_closure_rate: 'אחוז סגירה יומי',
        months_case_count: 'מספר מקרים חודשי',
        individually: 'באופן אישי',
        full: 'הכול',
        received: 'התקבל',
        report: 'דווח',
        regional_abbreviations: 'קיצורים אזוריים',
        name_of_organisation: 'שם הארגון',
        form_of_documents: 'צורת המסמכים',
        statistical_coverage: 'תחום הסטטיסטיקה',
        requiredMsg: 'חסר מידע חובה!',
        singlemonth_multiregional_composite_map: 'דוח משולב',
        statistical_for_tw_weeks: 'נתונים ל-12 השבועות האחרונים',
        weekly_case_count: 'מספר מקרים שבועי',
        accu_mon_sel_simultaneously:
            'לא ניתן לבחור בו זמנית את "מספר מקרים חודשי" ו"אחוז סגירה מצטבר"!',
        mcc_mm_sr: 'עבור "מספר מקרים חודשי", יש לבחור מספר חודשים ואזור אחד',
        acr_mm_sr: 'עבור "אחוז סגירה מצטבר", יש לבחור חודש אחד ומספר אזורים',
        distribution_Holding: 'הפצת החזקות',
        hour_response_rate: 'אחוז תגובות',
        Vehicle_fleet_size: 'גודל צי הרכב לפי דגם',
        num_of_cases: 'מספר מקרים',
        ratio: 'יחס',
        techl_inquiry_ratio: 'יחס פניות טכניות',
        close_logic: 'סטטיסטיקת אחוז סגירה',
        case_closure_rate: 'אחוז סגירת מקרים',
        technical_closure_rate: 'אחוז סגירה טכני',
        doc_stats_scope: 'תחום סטטיסטיקת המסמכים',
    },
};
